import { ProgressButtonWebElementBase } from './ProgressButtonWebElementBase';
import { By } from 'selenium-webdriver';

/**
 * The component WebElement for [oj-c-progress-button](../../jsdocs/oj-c.ProgressButton.html).
 * Do not instantiate this class directly, instead, use
 * [findProgressButton](../functions/findProgressButton.html).
 */
export class ProgressButtonWebElement extends ProgressButtonWebElementBase {
  // Put overrides here

  /**
   * Perform a click on the button
   */
  doAction() {
    return this.click();
  }

  /**
   * Perform a click on the button
   */
  async click() {
    // Find the <button> element to click so that it can receive focus
    const button = await this.findElement(By.css('button'));
    return button.click();
  }
}
